import Button from "components/shared/button/Button";
import GuiContext from "config/context/guiContext";
import ThemeContext from "config/context/themeContext";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Aside.module.css";
import { useClearAuthKeys } from "api/authentication/usePrivateKey";
import { useUpdateDatabaseStructure } from "api/database/useDatabase";
import TableContext from "config/context/tableContext";

const Aside = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const { dark } = useContext(ThemeContext);
  const { tableStructures } = useContext(TableContext);
  const {
    userData: { version },
    compositionsContext,
    logOut,
  } = useContext(GuiContext);
  const { updateDatabaseStructure, loading } = useUpdateDatabaseStructure();

  const { clearAuthKeys } = useClearAuthKeys();

  const [maximized, setMaximized] = useState(false);

  const pathMatchRoute = (route) => {
    return route === pathname;
  };

  useEffect(() => {
    updateDatabaseStructure()
  }, []);

  const handleCompositionDependentNavigation = (e) => {
    let navId = e.target.id;

    // Traverse up the DOM to find the element with the ID if the clicked element doesn't have it
    let currentElement = e.target;
    while (!navId && currentElement) {
      currentElement = currentElement.parentElement;
      navId = currentElement?.id;
    }

    // Ensure compositionsContext and compositions exist
    if (!tableStructures) {
      console.warn("No compositions context or compositions undefined");
      navigate("/add-composition"); // Fallback if compositionsContext is missing or empty
      return;
    }

    if (navId === "compositionsNav") {
      let destination =
        tableStructures.length > 0
          ? "/compositions"
          : (!loading ? "/add-composition" : "");
      navigate(destination);
    } else if (navId === "permissionsNav") {
      navigate("/permissions");
    }
  };

  const compositionsOrSetUpDatabase = () => {
    return (
      pathMatchRoute("/compositions") || pathMatchRoute("/add-composition")
    );
  };

  const handleLogout = async () => {
    try {
      await clearAuthKeys();
      logOut();
    } catch (error) {
      // console.error("Error during logout process:", error);
    }
  }


  return (
    <div
      className={`${styles.aside} ${maximized ? styles.maximized : ""} ${dark ? styles.dark : ""
        }`}
    >
      <div className={`${styles.phoneNavContainer}`}>
        <div>
          <Link to="/dashboard" onClick={() => setMaximized(false)}>
            <img src={`./img/${dark ? "logo-dark" : "logo"}.png`} alt="logo" />
          </Link>
        </div>
        <div>
          <Button
            buttonType="text"
            onClick={() => setMaximized((prev) => !prev)}
          >
            <img
              src={
                maximized
                  ? `./img/aside/cross${dark ? "-light" : ""}.svg`
                  : `./img/aside/hamburger${dark ? "-light" : ""}.svg`
              }
              alt="menu"
              width={24}
              height={24}
            />
          </Button>
        </div>
      </div>
      <aside className={`${styles.asideNav}`}>
        {!maximized && (
          <div className={styles.logo}>
            <Link to="/" onClick={() => setMaximized(false)}>
              <img
                src={`./img/${dark ? "logo-dark" : "logo"}.png`}
                alt="logo"
              />
            </Link>
          </div>
        )}
        <div className="container column align-center gap-1">
          <Link to={"/dashboard"} onClick={() => setMaximized(false)}>
            <div
              data-route="dashboard"
              className={`${styles.tabButton} ${pathMatchRoute("/dashboard") ? styles.active : ""
                } column align-center`}
            >
              <img
                width={18}
                height={18}
                src={`./img/aside/dashboard${pathMatchRoute("/dashboard") ? "-active" : ""
                  }.png`}
                alt="dashboard"
              />
              <p>Dashboard</p>
            </div>
          </Link>
          {/* <Link to={"/databases"} onClick={() => setMaximized(false)}>
            <div
              data-route="databases"
              className={`${styles.tabButton} ${pathMatchRoute("/databases") ? styles.active : ""
                } column align-center`}
            >
              <img
                width={18}
                height={18}
                src={`/img/aside/database${pathMatchRoute("/databases") ? "-active" : ""
                  }.png`}
                alt="dashboards"
              />
              <p>Databases</p>
            </div>
          </Link> */}
          <div
            id="compositionsNav"
            onClick={(e) => {
              handleCompositionDependentNavigation(e);
              setMaximized(false);
            }}
            className={`${styles.tabButton} ${compositionsOrSetUpDatabase() ? styles.active : ""
              } column align-center`}
            style={{ cursor: "pointer" }}
          >
            <img
              width={24}
              height={24}
              src={`./img/aside/compositions${compositionsOrSetUpDatabase() ? "-active" : ""
                }.svg`}
              alt="compositions"
            />
            <p>Compositions</p>
          </div>
          <div
            id="permissionsNav"
            onClick={(e) => {
              handleCompositionDependentNavigation(e);
              setMaximized(false);
            }}
            className={`${styles.tabButton} ${pathMatchRoute("/permissions") ? styles.active : ""
              } column align-center`}
            style={{ cursor: "pointer" }}
          >
            <img
              width={24}
              height={24}
              src={`./img/aside/permissions${pathMatchRoute("/permissions") ? "-active" : ""
                }.svg`}
              alt="permissions"
            />
            <p>Permissions</p>
          </div>
          <Link to={"/plugins"} onClick={() => setMaximized(false)}>
            <div
              className={`${styles.tabButton} ${pathMatchRoute("/plugins") ? styles.active : ""
                } column align-center`}
            >
              <img
                width={20}
                height={20}
                src={`./img/aside/plugins${pathMatchRoute("/plugins") ? "-active" : ""
                  }.png`}
                alt="plugins"
              />
              <p>Plugins</p>
            </div>
          </Link>
          {/* <Link to={"/templates"} onClick={() => setMaximized(false)}>
            <div
              className={`${styles.tabButton} ${pathMatchRoute("/templates") ? styles.active : ""
                } column align-center`}
            >
              <img
                width={20}
                height={20}
                src={`./img/aside/templates${pathMatchRoute("/templates") ? "-active" : ""
                  }.png`}
                alt="templates"
              />
              <p>Templates</p>
            </div>
          </Link> */}
          <Link to={"/settings"} onClick={() => setMaximized(false)}>
            <div
              className={`${styles.tabButton} ${pathMatchRoute("/settings") ? styles.active : ""
                } column align-center`}
            >
              <img
                width={20}
                height={20}
                src={`./img/aside/settings${pathMatchRoute("/settings") ? "-active" : ""
                  }.png`}
                alt="settings"
              />
              <p>Settings</p>
            </div>
          </Link>
        </div>
        <div className="column align-center gap-1">
          <button
            className={`${styles.logOut} ${styles.tabButton}`}
            onClick={() => handleLogout()}
          >
            <img
              width={24}
              height={24}
              src={`./img/aside/logout${dark ? "-dark" : ""}.svg`}
              alt="logout"
            />
            <p>Log Out</p>
          </button>
          <p className={styles.version}>{version}</p>
        </div>
      </aside>
    </div>
  );
};

export default Aside;
